import {createBrowserHistory} from 'history';
import {FC, useEffect, useState} from 'react';
import {Router} from 'react-router-dom';

import {useDomainConfig} from '../../../provider/domain-config/domain-config-hook';
import {initSmartLook, initUsertour} from '../../../provider/domain-config/init-scripts/init-scripts';
import {ROUTING_BY_DOMAIN} from '../app-const';

import {browserHistory, initHistory} from './helpers/history';
import {Routing as DefaultRouting} from './routing';

export function RoutingByDomain(): JSX.Element | null {
    const {domainName, basename, isUseSmartlook, isUseUsertour} = useDomainConfig();
    const [isHistoryInitialized, setIsHistoryInitialized] = useState(false);

    useEffect(() => {
        if (isUseSmartlook) {
            initSmartLook();
        }

        if (isUseUsertour) {
            initUsertour();
        }
    }, [isUseSmartlook, isUseUsertour]);

    useEffect(() => {
        initHistory(basename);
        setIsHistoryInitialized(true);
    }, [basename]);

    // Завершаем активный (не доведённый до конца) тур Usertour при смене страницы,
    // иначе он остаётся «висеть» и блокирует автостарт тура на новой странице.
    // Завязка именно на pathname (а не query/hash) сохраняет туры, которые идут
    // через смену query-параметра на одном пути (онбординг Сторлокатора).
    useEffect(() => {
        if (!isUseUsertour || !isHistoryInitialized || !browserHistory) {
            return;
        }

        const history = browserHistory;
        let lastPathname = history.location.pathname;

        // eslint-disable-next-line consistent-return
        return history.listen((location) => {
            if (location.pathname !== lastPathname) {
                lastPathname = location.pathname;
                window.usertour?.endAll().catch(() => {
                    // тур мог быть уже завершён — ошибку игнорируем
                });
            }
        });
    }, [isUseUsertour, isHistoryInitialized]);

    if (!isHistoryInitialized) {
        return null;
    }

    if (!browserHistory) {
        // don't throw an error, app might still be usable
        console.error("History did't initialize");
    }

    const Routing: FC = ROUTING_BY_DOMAIN[domainName] || DefaultRouting;

    return (
        <Router history={browserHistory || createBrowserHistory()}>
            <Routing />
        </Router>
    );
}
